import HowToUseItem from './HowToUseItem'

export default HowToUseItem
